import {
  migrateReadingLevel,
  migrateWritingLevel,
  type ReadingLevel,
  type WritingLevel,
} from '@skjv/common';

/** Oldest reading shape ('NONE'/'WORDS'/…) → legacy 7-value enum, then
 *  through the common migrator into the current levels. */
export function convertReadingLevel(oldLevel: string): ReadingLevel {
  const toLegacy: Record<string, string> = {
    NONE: 'LETTERS',
    LETTERS: 'LETTERS',
    WORDS: 'SINGLE_SYLLABLE_WORD',
    SINGLE_VERSE: 'SINGLE_VERSE',
    SHORT_PASSAGE: 'SHORT_PASSAGE',
    LONG_PASSAGE: 'LONG_PASSAGE',
  };
  return migrateReadingLevel(toLegacy[oldLevel] || 'LETTERS');
}

/** Oldest numeric writing scale → legacy 6-value enum, then through the
 *  common migrator into the current levels. */
export function convertWritingLevel(oldLevel: number): WritingLevel {
  const legacy =
    oldLevel < 0
      ? 'NONE'
      : oldLevel < 20
        ? 'LETTERS'
        : oldLevel < 30
          ? 'SINGLE_SYLLABLE_WORD'
          : oldLevel < 40
            ? 'MULTI_SYLLABLE_WORD'
            : oldLevel < 50
              ? 'SHORT_SENTENCE'
              : 'LONG_SENTENCE';
  return migrateWritingLevel(legacy);
}
